var _g, _path, _g2, _circle, _circle2, _circle3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscopePanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Component 641 \\u2013 247",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 45332"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z",
    "data-name": "Rectangle 15370"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M9.287 15.973h4.373s1.458-.646 1.458-1.442V4.44c0-.8-1.458-1.442-1.458-1.442H9.287s-1.458.65-1.458 1.442v10.091c0 .796 1.458 1.442 1.458 1.442Zm13.849 5.767h-.059a8.554 8.554 0 0 0 2.245-5.767 8.708 8.708 0 0 0-8.747-8.65v2.883a5.767 5.767 0 1 1 0 11.533H4.185a2.175 2.175 0 0 0-2.187 2.163.725.725 0 0 0 .729.721h21.871a.725.725 0 0 0 .729-.721 2.175 2.175 0 0 0-2.191-2.162Zm-16.4-1.442h9.475a.362.362 0 0 0 .364-.36v-.721a.362.362 0 0 0-.364-.36H6.736a.362.362 0 0 0-.364.36v.721a.362.362 0 0 0 .364.36Z",
    "data-name": "Icon awesome-microscope"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Path 46476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 32.25H17c-.68925 0-1.25-.56075-1.25-1.25V18c0-.68925.56075-1.25 1.25-1.25h14c.68925095 0 1.25.56075 1.25 1.25v13c0 .68925-.56074905 1.25-1.25 1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M17 17.5c-.27569962 0-.5.22430038-.5.5v13c0 .27569962.22430038.5.5.5h14c.27569962 0 .5-.22430038.5-.5V18c0-.27569962-.22430038-.5-.5-.5H17m0-1.5h14c1.10457039 0 2 .89542961 2 2v13c0 1.10457039-.89542961 2-2 2H17c-1.10457039 0-2-.89542961-2-2V18c0-1.10457039.89542961-2 2-2Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    fill: "#0c6972",
    "data-name": "Ellipse 4845",
    transform: "translate(18 19.25)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    fill: "#0c6972",
    "data-name": "Ellipse 4846",
    transform: "translate(18 23.25)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    fill: "#0c6972",
    "data-name": "Ellipse 4847",
    transform: "translate(18 27.25)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2.5,
    fill: "#0c6972",
    "data-name": "Rectangle 15972",
    rx: 1,
    transform: "translate(22 19.25)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2.5,
    fill: "#0c6972",
    "data-name": "Rectangle 15973",
    rx: 1,
    transform: "translate(22 23.25)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2.5,
    fill: "#0c6972",
    "data-name": "Rectangle 15974",
    rx: 1,
    transform: "translate(22 27.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscopePanel);
export default __webpack_public_path__ + "static/media/microscope-panel.0a3fe89beae93f07594fc368d1d3fb58.svg";
export { ForwardRef as ReactComponent };